module.exports = __webpack_public_path__ + "img/ve.6f3250ea.svg";